import * as React from "react"
import { motion, useReducedMotion } from "motion/react"

import { cn } from "../../lib/utils"

export interface TypingIndicatorProps {
  className?: string
}

/**
 * Three pulsing dots — the AI-Native "bot is typing" affordance. Inherits the
 * current text color (use inside a coloured bubble). Renders static dots when
 * reduced-motion is requested.
 */
const TypingIndicator: React.FC<TypingIndicatorProps> = ({ className }) => {
  const reduce = useReducedMotion()
  return (
    <div
      className={cn("flex items-center gap-1", className)}
      role="status"
      aria-label="Sta scrivendo"
    >
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="h-2 w-2 rounded-full bg-current"
          style={{ opacity: 0.5 }}
          animate={reduce ? undefined : { y: [0, -4, 0], opacity: [0.5, 1, 0.5] }}
          transition={
            reduce
              ? undefined
              : { duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: i * 0.15 }
          }
        />
      ))}
    </div>
  )
}

TypingIndicator.displayName = "TypingIndicator"

export { TypingIndicator }
